import { useExtraData } from "../DataContext.js";

const AuthorBioPanel = ({tabIndex, sel}) => {
        
    let { _source } = useExtraData();

    const name = `tab-${tabIndex}`;

    let authorBioHtml = "";
    authorBioHtml += `<div class="noteSection"><h4 class="titleText">Author biography</h4><div className="textBlock">${_source.author_bio}</div></div>`;

    return(
        <div id={name} key={`tabindex${tabIndex}`} className={`tabContent ${name == sel ? "current" : ""}`}>
            <div className="columns wrap" dangerouslySetInnerHTML={{__html: authorBioHtml}} />
        </div>
    )
}

export default AuthorBioPanel;